import type { ReactNode } from 'react';
import type { PanelSplitRect } from '@/components/desktop-side-panel/panel-split-frame';

/**
 * A tab of a view that places its own tabs (a page of the browser, a terminal), where the panel
 * shows it: alone, filling the view (`null`); split, over its cell, a click making it the active
 * tab; not shown (`undefined`), hidden, or kept laid out and painting (`keepPainting`, a page an
 * agent drives) transparent under the others, out of pointer reach.
 */
export function PlacedTab({
  id,
  placement,
  keepPainting = false,
  onSelect,
  children,
}: {
  id: string;
  placement: PanelSplitRect | null | undefined;
  keepPainting?: boolean;
  onSelect: (id: string) => void;
  children: ReactNode;
}) {
  return (
    <div
      aria-hidden={placement === undefined ? true : undefined}
      className={
        placement === null
          ? 'h-full'
          : placement !== undefined
            ? 'pointer-events-auto absolute'
            : keepPainting
              ? 'pointer-events-none absolute inset-0 -z-10 opacity-0'
              : 'hidden'
      }
      data-panel-split-target={placement ? id : undefined}
      onPointerDownCapture={placement ? () => onSelect(id) : undefined}
      style={placement ?? undefined}
    >
      {children}
    </div>
  );
}
